import {
  VerticalNavigation,
  Content,
  Page,
  ErrorHandler,
} from '@trufla-technology/trumarket-react-design-system';
import {
  useAuthContext,
  useBrandingContext,
} from '@trufla-technology/trufla-trudomain/dist/lib';
import { useHistory } from 'react-router-dom';
import './style.scss';
import { CompanyDetails } from './CompanyDetails/index';
import { TeamsRoutes } from './Teams/index';
import { CompanyProducts } from '../CompanyProducts';
import { ConfigurationRoutes } from './SystemConfiguration/index';
import { UsersList } from './UserListFile';
import { Branding } from '../Branding/index';

export const Configurations = () => {
  const history = useHistory();
  const { isPermitted } = useAuthContext();
  const {
    branding: { logoUrl },
  } = useBrandingContext();

  const UnauthorizedRoute = () => (
    <ErrorHandler
      logoUrl={logoUrl!}
      status="401"
      messageError="Unauthorized"
      onClick={() => history.push('/')}
    />
  );
  const routeItems = [
    {
      label: 'Company Details',
      linkTo: '/configurations/company-details/*',
      key: 'company-details',
      component: isPermitted('getCompany') ? CompanyDetails : UnauthorizedRoute,
    },

    {
      label: 'Branding',
      linkTo: '/configurations/branding',
      key: 'branding',
      component: Branding,
    },

    isPermitted('listProductDefinitions')
      ? {
          label: 'Products',
          linkTo: '/configurations/products',
          key: 'products',
          component: CompanyProducts,
        }
      : null,

    isPermitted('listUsers')
      ? {
          label: 'Users',
          linkTo: '/configurations/users',
          key: 'users',
          component: UsersList,
        }
      : null,
    isPermitted('getTeams')
      ? {
          label: 'Teams',
          linkTo: '/configurations/teams/*',
          key: 'teams',
          component: TeamsRoutes,
        }
      : null,
    isPermitted('getTeams')
      ? {
          label: 'System Configuration',
          linkTo: '/configurations/system-configuration/*',
          key: 'system-configuration',
          component: ConfigurationRoutes,
        }
      : null,
  ];
  return (
    <div className="configuration-page">
      <Content>
        <Page>
          <VerticalNavigation navItems={routeItems.filter((item) => item)} />
        </Page>
      </Content>
    </div>
  );
};
